import React from 'react';
import classes from './hero.module.css';

const Hero = () => {
    return (
        <div className={ classes.hero }>
            <h1 className={classes.introduction }>Hi! I'm Yusuke Asai, a student at Graduate School of Engineering, Nagoya University who likes to code.</h1>
        </div>
    );
}

export default Hero;